// Corrected import statement
import Axios, { REQUEST_METHOD } from "../axios";

export function apiSkipVerification(userId) {
  return Axios.fetch({
    url: "/auth/skip-verification", // <-- ASCII hyphen here
    method: REQUEST_METHOD.POST,
    data: { userId }, // just need the ID
  });
}
// move this one
export async function apiCheckUsername(username) {
  return Axios.fetch({
    url: "/users/suggest-username-if-it-exist",
    method: REQUEST_METHOD.GET,
    data: { username },
  }).catch((error) => {
    console.error("Error checking username:", error);
    throw error;
  });
}

// check this one out
export async function apiVerifyUserByPhoneNumber(phoneNumber) {
  const params = { phoneNumber };
  const queryString = new URLSearchParams(params).toString();
  console.log(`Request URL: /users/accountholder-mobile-verify?${queryString}`);
  return Axios.fetch({
    url: "/auth/accountholder-mobile-verify",
    method: REQUEST_METHOD.GET,
    params, // Axios should automatically handle this as a query string
  });
}

// check this one out
export function apiCurrentUserPswrdReset(userId, newPassword) {
  console.log("📤 Sending password reset request:", { userId, newPassword });

  return Axios.fetch({
    url: "/auth/reset-password",
    method: REQUEST_METHOD.POST,
    data: { userId, newPassword },
  });
}

export function apiAddAcctAtributes(data) {
  return Axios.fetch({
    url: "/auth/add-acct-attributes",
    method: REQUEST_METHOD.POST,
    data,
  });
}

export function apiCanceledSignupDeleteUserRecord(userId) {
  return Axios.fetch({
    url: `/users/canceled-signup/${userId}`,
    method: REQUEST_METHOD.DELETE,
  });
}

// signUp function using the custom Axios instance
export function apiSignUp(userData) {
  return Axios.fetch({
    url: "/auth/sign-up",
    method: REQUEST_METHOD.POST,
    data: userData,
  });
}

// Function to check phone number and username
export async function apiCheckPhoneNumberAndUsername(phoneNumber, username) {
  return Axios.fetch({
    url: "/users/check-phone-and-username",
    method: REQUEST_METHOD.GET,
    params: { phoneNumber, username },
  }).catch((error) => {
    console.error("Error checking phone number and username:", error);
    throw error;
  });
}
export function apiSigninUsername(username, password) {
  return Axios.fetch({
    url: "/auth/sign-in-username",
    method: REQUEST_METHOD.POST,
    data: {
      username,
      password,
    },
  });
}

export async function apiSigninMobile(phoneNumber, password) {
  return Axios.fetch({
    url: "/auth/sign-in-mobile",
    method: REQUEST_METHOD.POST,
    data: {
      phoneNumber,
      password,
    },
  });
}

export async function apiSigninEmail(email, password) {
  return Axios.fetch({
    url: "/auth/sign-in-email",
    method: REQUEST_METHOD.POST,
    data: {
      email,
      password,
    },
  });
}
export async function apiCheckEmail(email) {
  try {
    // pass email as a query-param instead of string-concatenating
    const response = await Axios.fetch({
      url: "/auth/check-email",
      method: REQUEST_METHOD.GET,
      params: { email },
    });
    // Axios.fetch now returns the full Axios response
    // so we explicitly pull out the JSON body here
    return response.data;
  } catch (err) {
    // let the caller handle the UI error message
    throw err;
  }
}

export function apiLogoutMember(userId) {
  return Axios.fetch({
    url: `/auth/logout-member/${userId}`,
    method: REQUEST_METHOD.POST,
  });
}


// Function to call campaign payment API
// Corrected apiCampaignPayment function using your Axios wrapper
export async function apiCampaignPayment(data) {
  return Axios.fetch({
    url: "/campaign/campaign-payment-type",
    method: REQUEST_METHOD.POST,
    data, // Pass the entire payload here
  });
}

export async function calculateTotalCostAndItems(data) {
  return Axios.fetch({
    url: "/payment/calculate-total-cost-and-items",
    method: REQUEST_METHOD.POST,
    data,
  });
}

export const apiFetchInitialTransactionHistory = (sourceId, limit = 20) => {
  return Axios.fetch({
    url: "/payment/get-inital-array-transaction-history",
    method: REQUEST_METHOD.GET,
    params: {
      sourceId,
      limit, // No `lastCreatedAt` for the initial load
    },
  });
};

export const apiFetchMoreTransactionHistory = (
  sourceId,
  lastCreatedAt,
  limit = 20
) => {
  return Axios.fetch({
    url: "/payment/fetch-view-moretransaction-history",
    method: REQUEST_METHOD.GET,
    params: {
      sourceId,
      lastCreatedAt, // Use `lastCreatedAt` for pagination
      limit,
    },
  });
};

export async function apiVerifyOtp({ userId, otpCode }) {
  try {
    const response = await Axios.fetch({
      url: "/auth/verify-otp",
      method: REQUEST_METHOD.POST,
      data: { userId, otpCode },
    });
    return response;
  } catch (error) {
    console.error("Error in apiVerifyOtp:", error);
    throw error;
  }
}
export function apiVerifyOtpWhileLoggedIn({ userId, otpCode }) {
  return Axios.fetch({
    url: "/auth/verify-otp-while-logged-in",
    method: REQUEST_METHOD.POST,
    data: { userId, otpCode },
  });
}

export async function apiSendOtp({ phoneNumber }) {
  try {
    const response = await Axios.fetch({
      url: "/auth/send-otp",
      method: REQUEST_METHOD.POST,
      data: { phoneNumber },
    });
    return response;
  } catch (error) {
    console.error("Error in apiSendOtp:", error);
    throw error;
  }
}

export function apiFetchAcctPayTransactions(
  offset = 0,
  limit = 6,
  userId,
  rolePerformed
) {
  return Axios.fetch({
    url: "/auth/get-acct-pay-trans",
    method: REQUEST_METHOD.GET,
    params: { offset, limit, userId, rolePerformed },
  });
}

export function apiAutoSignIn({ userId }) {
  return Axios.fetch({
    url: "/auth/auto-sign-in",
    method: REQUEST_METHOD.POST,
    data: { userId },
  });
}
export function apiClearOtpToken(userId) {
  return Axios.fetch({
    url: "/auth/clear-otp-token",
    method: REQUEST_METHOD.POST,
    data: { userId }, // that’s all you need
  });
}
export function apiClearAuthToken(userId) {
  return Axios.fetch({
    url: "/auth/clear-auth-token",
    method: REQUEST_METHOD.POST,
    data: { userId }, // that’s all you need
  });
}

export function apiMemberSessions(userId, { signal } = {}) {
  return Axios.fetch({
    url: `/auth/custom-made-member-sessions/${userId}?wait=1`,
    method: REQUEST_METHOD.GET,
    signal,
    timeout: 35000, // > server timeout
    validateStatus: (s) => (s >= 200 && s < 300) || s === 204 || s === 503,
  });
}

// to do for protected branches and notifications check
export const apiFetchCurrentUserAttributes = (userId) => {
  return Axios.fetch({
    url: `/auth/fetch-current-user/${userId}`,
    method: REQUEST_METHOD.GET,
    params: { userId },
  });
};
export async function apiDeleteProfileImage(userId) {
  return Axios.fetch({
    url: "/uploads/delete-profile-image",
    method: REQUEST_METHOD.DELETE,
    data: { userId },
    headers: {
      "Content-Type": "application/json",
    },
  });
}


// protected branches and checks notifications
export function apiUpdateMemberEmail(loggedInAccountHolderId, email) {
  return Axios.fetch({
    url: `/auth/update-email`,
    method: REQUEST_METHOD.POST,
    data: { loggedInAccountHolderId, email },
  });
}

export function apiUpdateMemberUserName(loggedInAccountHolderId, username) {
  return Axios.fetch({
    url: `/auth/update-username`,
    method: REQUEST_METHOD.POST,
    data: { loggedInAccountHolderId, username },
  });
}

export function apiUpdateMemberMobile(loggedInAccountHolderId, phoneNumber) {
  return Axios.fetch({
    url: `/auth/update-member-mobile`,
    method: REQUEST_METHOD.POST,
    data: { loggedInAccountHolderId, phoneNumber },
  });
}


export default {
  apiMemberSessions,
  apiVerifyOtpWhileLoggedIn,
  apiClearOtpToken,
  apiClearAuthToken,
  apiAutoSignIn,
  apiFetchAcctPayTransactions,
  apiSendOtp,
  apiVerifyOtp,
  apiFetchInitialTransactionHistory,
  apiFetchMoreTransactionHistory,
  apiCampaignPayment,
  calculateTotalCostAndItems,
  // apiDeleteAdMediaS3DataBaseRecord,
  apiUpdateMemberEmail,
  apiUpdateMemberUserName,
  apiUpdateMemberMobile,
  apiCheckEmail,
  apiDeleteProfileImage,
  apiSigninUsername,
  apiSigninMobile,
  apiSigninEmail,
  apiCheckPhoneNumberAndUsername,
  apiCheckUsername,
  apiSignUp,
  apiCanceledSignupDeleteUserRecord,
  apiAddAcctAtributes,
  apiCurrentUserPswrdReset,
  apiVerifyUserByPhoneNumber,
  apiSkipVerification,
  apiLogoutMember,
  apiFetchCurrentUserAttributes,
};

// reaasons for post signin
// Security: Sensitive information such as passwords should not be
// sent in the URL, which is what happens with a GET request. URLs can be
// logged, bookmarked, or stored in browser history, which can expose sensitive
// information. POST requests, on the other hand, send data in the body of the request,
// which is not logged or stored in the same way.
